module.exports = __webpack_public_path__ + "static/media/omg_wow.62a93766.mp3";